import { useState } from 'react';
import PropTypes from 'prop-types';
import '../Filters/Filters.css';
import { ChevronDown } from '@/ui/icons';

// compact filter dropdown — a mono-kicker button that opens a
// multi-select checkbox menu. Replaces the prototype's pill row. Controlled:
// `value` is the array of selected option values ([] = "all"); `onChange`
// receives the next array. Styles: .fdrop/.fbtn/.fmenu in atoms.css.
export default function FilterDropdown({
  label,
  value = [],
  options,
  onChange,
  allLabel = 'Todas',
}) {
  const [open, setOpen] = useState(false);
  const sel = value || [];
  const active = sel.length > 0;
  const text =
    sel.length === 0
      ? allLabel
      : sel.length === 1
        ? (options.find((o) => o.value === sel[0]) || {}).label ||
          '1 seleccionado'
        : `${sel.length} seleccionados`;
  const toggle = (v) =>
    onChange(sel.includes(v) ? sel.filter((x) => x !== v) : sel.concat(v));

  return (
    <div className="fdrop">
      <button
        type="button"
        className={`fbtn${active ? ' fbtn--on' : ''}`}
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        <span className="fbtn__k">{label}</span>
        <span className="fbtn__v">{text}</span>
        <ChevronDown size={14} />
      </button>
      {open && (
        <>
          <div className="fdrop__scrim" onClick={() => setOpen(false)} />
          <div className="fmenu" role="menu">
            <button
              type="button"
              role="menuitemcheckbox"
              aria-checked={sel.length === 0}
              className={`fmenu__item${sel.length === 0 ? ' is-on' : ''}`}
              onClick={() => {
                onChange([]);
                setOpen(false);
              }}
            >
              <span className="fmenu__box" />
              <span className="fmenu__lbl">{allLabel}</span>
            </button>
            {options.map((o) => {
              const on = sel.includes(o.value);
              return (
                <button
                  key={o.value}
                  type="button"
                  role="menuitemcheckbox"
                  aria-checked={on}
                  className={`fmenu__item${on ? ' is-on' : ''}`}
                  onClick={() => toggle(o.value)}
                >
                  <span className="fmenu__box" />
                  <span className="fmenu__lbl">{o.label}</span>
                  {o.n != null && <span className="fmenu__n">{o.n}</span>}
                </button>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}

FilterDropdown.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ),
  options: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      label: PropTypes.node,
      n: PropTypes.number,
    }),
  ).isRequired,
  onChange: PropTypes.func.isRequired,
  allLabel: PropTypes.string,
};
